<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/expenses">{{ $t('expense_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('expense_create') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <b-btn variant="outline-primary no-bor" size="sm" @click="onSave"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.model.AccountId.required">- សូមធ្វើការបញ្ជូលប្រភេទចំណាយ</div>
                        <div class="error" v-if="!$v.model.Amount.required || !$v.model.Amount.minValue">{{$t('error.minZero')}}</div>
                        <div class="error" v-if="!$v.model.Description.required">- សូមធ្វើការបញ្ជូលបរិយាយចំណាយ</div>
                        <div class="error" v-if="!$v.date.required">- សូមធ្វើការបញ្ជូលកាលបរិច្ឆេទទទួលចំណាយ</div>
                    </div>
                    <form ref="form">
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.AccountId.$error }">
                                    <label class="label-control blue">{{$t('expense_type')}}</label>
                                    <div>
                                        <select class="form-control form-control-sm" v-model="model.AccountId" @change="accountChange">
                                            <option value=""></option>
                                            <option v-for="(ret,index) in expenses" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group" :class="{ 'form-group-error': $v.date.$error }">
                                    <label class="label-control blue">{{$t('date')}}</label>
                                    <div>
                                        <input type="date" class="form-control form-control-sm" v-model="date"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.CashId.$error }">
                                    <label class="label-control blue">{{$t('payment_menthod')}}</label>
                                    <div>
                                        <select class="form-control form-control-sm" v-model="$v.model.CashId.$model" @change="bankChange">
                                            <option v-for="(ret,index) in banks" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>                
                            <div class="col-sm-3">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.Amount.$error }">
                                    <label class="label-control blue">{{$t('amount')}}</label>
                                    <div>
                                        <input type="number" class="form-control form-control-sm" min="0" v-model="$v.model.Amount.$model"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <b-form-group class="label-control blue" :label="$t('description')" :class="{ 'form-group-error': $v.model.Description.$error }">
                                    <b-form-textarea class="form-control-sm" v-model="model.Description"/>
                                </b-form-group>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, minValue } from 'vuelidate/lib/validators'
    export default {
        data: function(){
            return {
                model:{
                    Date: '',
                    Description: '',
                    AccountId: '',
                    AccountName: '',
                    CashId: '',
                    CashName: '',
                    Amount: 0
                },
                date: this.$now().format('YYYY-MM-DD'),
                expenses: [],
                banks: [],
                actionLink: 'accounting/bill/save'
            }
        },
        validations:{
            model: {
                AccountId: { required },
                CashId: { required },
                Description: { required },
                Amount: { required, minValue: minValue(0) }
            },
            date: { required }
        },
        created: function(){
            var id = this.$route.params.id;
            this.expenseList();
            this.bankList();
            if(id !== undefined && id !== null && id !== ''){
                this.findById(id);
            }
        },
        methods: {
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('accounting/bill/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Data;
                    }
                }).finally(function(){ loading.hide(); });
            },
            onSave(){
                this.$v.$touch();
                if(!this.$v.$invalid){
                    let loading = this.$loading.show();
                    var req = {
                        Header: {
                            Date: this.date,
                            Amount: this.model.Amount,
                            AccountId: this.model.CashId,
                            AccountName: this.model.CashName,
                            Description: this.model.Description
                        },
                        Lines: [
                            {
                                Amount: this.model.Amount,
                                AccountId: this.model.AccountId,
                                AccountName: this.model.AccountName
                            }
                        ]
                    };
                    this.$api().post(this.actionLink, req).then(res => {
                        if(this.$isValid(res)){
                            this.$router.push('/expenses');
                        }
                    }).finally(function(){ loading.hide(); });
                }
            },
            expenseList(){
                this.$api().post('accounting/account/groups', { AccountTypeNames: ['Expense'] }).then(res => {
                    if(this.$isValid(res)){
                        this.expenses = res.data.Json.Accounts;
                    }
                });
            },
            bankList(){
                this.$api().post('accounting/account/types', { AccountTypeNames: ['Bank'] }).then(res => {
                    if(this.$isValid(res)){
                        this.banks = res.data.Json.Accounts;
                    }
                });
            },
            bankChange(){
                var bank = this.banks.find(element => element.Id == this.model.CashId );
                if(bank != undefined) this.model.CashName = bank.Name;
            },
            accountChange(){
                var bank = this.expenses.find(element => element.Id == this.model.AccountId);
                if(bank != undefined) this.model.AccountName = bank.Name;
            }
        },
    }
</script>